
<template>
    <div>
        <gofix-card title="security deposit" v-bind:key="index + 'extra'" v-for="(item, index) in value">
            <template slot="gofixCard:right_header">
                <div class="contract-attachment-action">
                    <b-button class="btnDelete" @click="removeOption(index, item)" title="Delete" v-b-tooltip.hover><i class="fa fa-trash-o"></i></b-button>
                </div>
            </template>
            <b-row class="">
                <b-col md="4">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-dropdown
                                label="Type"
                                :options="optionsType"
                                v-model="item.security_deposit.json_content.type">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input label="banker guarantee issuing bank" v-model="item.security_deposit.json_content.issuing_bank"></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input label="banker guarantee number" v-model="item.security_deposit.json_content.cheque_number"></gofix-form-input>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-number
                                label="amount"
                                v-model="item.security_deposit.json_content.amount"
                                prefix="$">
                            </gofix-form-input-number>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <hr class="mt-3 mb-3"/>
            <template slot="gofixCard:after_card">
                <div class="gofixCardHeader pt-0">
                    <h3 class="title">Work injury compensation</h3>
                </div>
                <div class="gofixCardContent">
                    <b-row>
                        <b-col md="4">
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-input label="Insurer" v-model="item.work_injury_compensation.json_content.insurer"></gofix-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-input label="policy number" v-model="item.work_injury_compensation.json_content.policy_number"></gofix-form-input>
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input-date
                                        v-model="item.work_injury_compensation.json_content.issue_date"
                                        label="issue date">
                                    </gofix-form-input-date>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                             <b-row>
                                <b-col md="6">
                                    <gofix-form-input-number
                                        label="policy premium"
                                        v-model="item.work_injury_compensation.json_content.policy_premium"
                                        prefix="$">
                                    </gofix-form-input-number>    
                                </b-col>
                            </b-row> 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-row>
                                <b-col md="6" class="toLableLeft">
                                    <gofix-form-input-date
                                        v-model="item.work_injury_compensation.json_content.start_date"
                                        label="period">
                                    </gofix-form-input-date>
                                    <label class="toLableCenter">To</label>
                                </b-col>
                                <b-col md="6" class="toLableRight">
                                    <gofix-form-input-date
                                        v-model="item.work_injury_compensation.json_content.end_date"
                                        label=" ">
                                    </gofix-form-input-date>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-input label="policy premium receipt number" desc="" v-model="item.work_injury_compensation.json_content.policy_receipt"></gofix-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">      
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12"  class="pl-25 mt-20">
                            <b-form-checkbox @change="clone(index)" value="1" class="inline-block mr-12"></b-form-checkbox> <label>Use same information for “Public Liability Claim Insurance”</label>
                        </b-col>
                    </b-row>
                    <hr class="mt-3 mb-3"/>
                </div>
                <div class="gofixCardHeader pt-0">
                    <h3 class="title">public liability claim insurance</h3>
                </div>
                <div class="gofixCardContent">
                    <b-row>
                        <b-col md="4">
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-input label="Insurer" v-model="item.public_liability_claim_insurance.json_content.insurer"></gofix-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-input label="policy number" v-model="item.public_liability_claim_insurance.json_content.policy_number"></gofix-form-input>
                                </b-col>
                                <b-col md="6">
                                    <gofix-form-input-date
                                        v-model="item.public_liability_claim_insurance.json_content.issue_date"
                                        popoverDirection="top"
                                        label="issue date">
                                    </gofix-form-input-date>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col md="6">
                                    <gofix-form-input-number
                                        label="policy premium"
                                        v-model="item.public_liability_claim_insurance.json_content.policy_premium"
                                        prefix="$">
                                    </gofix-form-input-number>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-row>
                                <b-col md="6" class="toLableLeft">
                                    <gofix-form-input-date
                                        v-model="item.public_liability_claim_insurance.json_content.start_date"
                                        popoverDirection="top"
                                        label="period">
                                    </gofix-form-input-date>
                                    <label class="toLableCenter">To</label>
                                </b-col>
                                <b-col md="6" class="toLableRight">
                                    <gofix-form-input-date
                                        v-model="item.public_liability_claim_insurance.json_content.end_date"
                                        popoverDirection="top"
                                        label=" ">
                                    </gofix-form-input-date>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-input label="policy premium receipt number" desc="" v-model="item.public_liability_claim_insurance.json_content.policy_receipt"></gofix-form-input>
                                </b-col>
                                <b-col md="6" class="toLableRight">
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="4">
                        </b-col>
                    </b-row>
                </div>
            </template>
        </gofix-card>
    </div>
</template>
<script>
    export default {
        name: 'contract-extra-info',
        props: {
            value: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        data() {
            return {
                optionsType: [
                    `Banker's Guarantee`,
                    `Cheque`
                ],
            }
        },
        methods: {
            removeOption(index, item) {
                this.$emit('removeItem', 'extra_info', index, item);
            },
            clone(index) {
                this.$emit('clone', index);
            }
        }
    }
</script>
